import type { FormattingOptions } from "../createDurationFormatter";
import createDurationFormatter from "../createDurationFormatter";
import getAbbreviatedSingularPluralStrings from "./getAbbreviatedSingularPluralStrings";
import type { DurationProperties } from "../DurationTypes";
import type { FormatHandler } from "owa-measurement-formatter";

/** Creates a duration formatter using the plural rules of the given culture and the given strings */
export default function createAbbreviatedDurationFormatter(userCulture: string, options?: FormattingOptions, durationUnitsProps?: DurationProperties[], useSimplePluralForm?: boolean): FormatHandler {
    const singularPluralStrings = getAbbreviatedSingularPluralStrings();
    return createDurationFormatter(userCulture, singularPluralStrings, options, durationUnitsProps, useSimplePluralForm);
}
